






















import Vue from "vue";
import {Component, Prop} from "vue-property-decorator";
//@ts-ignore
import store from "../../../store";
import type {Player, PlayerRole} from "../../../../types";
import MessageHelper from "../../../helpers/MessageHelper";
import EventApi from "../../../api/EventsApi";

@Component({
    components: {},
})

/**
 * Компонент голосования в мафии
 */
export default class MafiaVoting extends Vue {
    @Prop({required: true}) private readonly period!: string;
    @Prop({required: true}) private readonly seat!: Player;

    private roleTypesMap: {[key: string]: number} = {
        citizen: 1,
        mafia: 2,
        seer: 3,
        widow: 4,
    };

    /**
     * ID текущего игрока
     * @private
     */
    private get playerId(): string
    {
        return store.getters.getPlayerId;
    }

    /**
     * Роль текущего игрока в автоматизации игры
     */
    private get currentPlayerRole(): PlayerRole|null
    {
        return store.getters.getPlayerAutomationRole(this.playerId);
    }

    /**
     * Показывать кнопку Kill
     * @private
     */
    private get showKillButton(): boolean
    {
        return !!this.currentPlayerRole
            && this.currentPlayerRole.value === this.roleTypesMap.mafia
            && this.period === 'night';
    }

    /**
     * Показывать кнопку Reveal
     * @private
     */
    private get showSeerButton(): boolean
    {
        return !!this.currentPlayerRole
            && this.playerId !== this.seat.id
            && this.currentPlayerRole.value === this.roleTypesMap.seer
            && this.period === 'night';
    }

    /**
     * Показывать кнопку Save
     * @private
     */
    private get showWidowButton(): boolean
    {
        return !!this.currentPlayerRole
            && this.currentPlayerRole.value === this.roleTypesMap.widow
            && this.period === 'night';
    }

    /**
     * Показывать кнопку Execute
     * @private
     */
    private get showExecuteButton(): boolean
    {
        return this.period === 'day' && this.playerId !== this.seat.id;
    }

    /**
     * Проголосовать
     * @private
     */
    private countVote(isExecution: boolean = false)
    {
        EventApi.triggerEvent(EventApi.START_SOUND, {sound: 'buttonClick'});

        MessageHelper.countVoteMessage({
            'option': this.seat.id,
            'group': 0,
        });

        EventApi.triggerEvent(EventApi.MAKE_VOTING_DECISION);
        EventApi.triggerEvent(EventApi.HIDE_EXTERNAL_VOTING);

        if (isExecution) {
            this.$emit('set-executed-id', this.seat.id);
        } else {
            this.$emit('set-night-action-id', this.seat.id);
        }

    }
}
